export default "__VITE_ASSET__1b46faa8__"